"use strict";
/**
 * Copyright 2014-present Palantir Technologies
 * @license MIT
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArcSVGDrawer = void 0;
var tslib_1 = require("tslib");
var svgDrawer_1 = require("./svgDrawer");
var ArcSVGDrawer = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(ArcSVGDrawer, _super);
    function ArcSVGDrawer() {
        return _super.call(this, "path", "arc fill") || this;
    }
    ArcSVGDrawer.prototype._applyDefaultAttributes = function (selection) {
        selection.style("stroke", "none");
    };
    return ArcSVGDrawer;
}(svgDrawer_1.SVGDrawer));
exports.ArcSVGDrawer = ArcSVGDrawer;



//////////////////
// WEBPACK FOOTER
// ./src/drawers/arcDrawer.ts
// module id = 51
// module chunks = 0